@import "../../sass/variables/variables";

.ux-notification-item {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  @media only screen and (min-width: $tablet) {
    display: block;
  }
}

.ux-notification-item__icon-wrapper {
  align-items: center;
  display: flex;
  margin-bottom: $dim-10;

  ux-icon {
    font-size: 48px;
  }
}

.ux-notification-item__source-date {
  display: flex;
  flex-direction: column;
  margin-left: 15px;

  .ux-notification-item__date-time {
    font-size: var(--ux-notification-item-date-time-font-size);
  }

  .ux-notification-item__date {
    margin-left: 10px;
  }

  .ux-notification-item__will-delete-in {
    display: inline-block;
    color: $color-gray-text;
    margin-left: 10px;
  }
}

.ux-notification-item__status-wrapper {
  position: absolute;
  right: 10px;
  top: 5px;
}

// Type modifier
.ux-notification-item--overview {
  align-items: flex-start;
}

.ux-notification-item--detail {
  @media only screen and (min-width: $desktop-s) {
    align-items: center;
  }

  .ux-notification-item__icon-wrapper {
    @media only screen and (min-width: $tablet) {
      width: 85px;
    }
    /* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
    ux-icon {
      @media only screen and (min-width: $tablet) {
        font-size: 48px * 1.33;
      }
    }
    /* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
  }
}
